// extracted by mini-css-extract-plugin
module.exports = {"adjustable-base-model-viewer-wrapper":"adjustableBaseModelViewer-module--adjustable-base-model-viewer-wrapper--3qE21"};